import { CancelResponseInterface } from '../interfaces/cancel-response.interface';
import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('CancelResponseModel')
export class CancelResponseModel implements CancelResponseInterface {
  @JsonProperty('Message', String)
  message: string = undefined;

  @JsonProperty('Status', String)
  status: string = undefined;

  @JsonProperty('VerificationId', String)
  verificationId: string = undefined;
}
